import {
  DocumentTextIcon,
  GiftIcon,
  InformationCircleIcon,
  PhoneIncomingIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
  ShoppingBagIcon,
  UserGroupIcon,
  QuestionMarkCircleIcon
} from "@heroicons/react/outline";

export const ResourcesData = [
  {
    name: "About Us",
    href: "about-us",
    icon: UserGroupIcon,
  },
  {
    name: "Contact Us",
    href: "contact-us",
    icon: PhoneIncomingIcon,
  },
  {
    name: "FAQ",
    href: "FAQ",
    icon: QuestionMarkCircleIcon,
  },
  {
    name: "404",
    href: "404",
    icon: InformationCircleIcon,
  },
];